<template>
    <div class="videoUploadCon">
      <div class="add" @click="addVideo">
        <img src="../../img/plus.png" alt="" />
      </div>
      <div class="videoItem" v-for="item in myPhotoList" :key="item.works_id">
        <div class="coverCon">
          <img :src="'https://collection2021-cos.chineseplus.net/'+item.cover" alt="" class="cover">
          <div class="fail" v-if="item.status == 2">
            <span>
              本作品参赛审核未通过，{{item.check_desc}}
            </span>
          </div>
          <div class="info">
            <span>{{item.title}}</span>
          </div>
        </div>
        <div class="hoverInfo">
          <div class="info">
            <span>{{item.title}}</span>
            <div class="des" v-if="item.status !== 2">
              {{item.desc}}
            </div>
            <div class="fail" v-if="item.status == 2">
                本作品参赛审核未通过，{{item.check_desc}}
            </div>
            <div class="operate">
              <!-- <div class="item" @click="checkPhoto(item.works_id)">
                <img src="../../img/playicon.png" alt="">
                <div>
                  查看
                </div>
              </div> -->
              <div class="item" @click="checkPhoto(item.works_id)">
                <img src="../../img/settingicon.png" alt="">
                <div>
                  管理
                </div>
              </div>
              <div class="item" v-if="item.status == 0||item.status == 2" @click="editPhoto(item.works_id)">
                <img src="../../img/editicon.png" alt="">
                <div>
                  编辑
                </div>
              </div>
              <div class="item" v-if="item.status == 0||item.status == 2" @click="deletePhoto(item.works_id)">
                <img src="../../img/deleteicon.png" alt="">
                <div>
                  删除
                </div>
              </div>
              <div class="item" v-if="item.status == 0||item.status == 2" @click="join(item.works_id)">
                <img src="../../img/m/flag_r1.png" alt="">
                <div>
                  参赛
                </div>
              </div>
              <div class="item isJoin" v-if="item.status == 3 || item.status == 1">
                <img src="../../img/join_black.png" alt=""  >
                <div v-if="item.status == 3">
                  审核中
                </div>
                <div v-if="item.status == 1">
                  已参赛
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <plogdialog v-if="dialogVisible" :id="editWorks_id"></plogdialog>
    </div>
</template>

<script>
import plogdialog from "./plogdialog"
import {mapGetters} from 'vuex'
export default {
    name: 'plogupload',
    components: {
      plogdialog
    },
    data: function () {
    return {
      isEdit: false,
      dialogVisible: false,
      myPhotoList: [],
      editWorks_id: ''

    };
  },
  created() {
    this.getMyPhotoList()
  },
  computed: {
    ...mapGetters(['getUserInfo']),
  },
  methods: {
    // 参赛
    join(works_id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$utils.postJson('/works/submitReview', {
        works_id
      }).then(res => {
        if(res.code == 1000) {
          this.$message.success(`作品已经提交审核，审核期间您的作品暂时不可以修改`);
          this.getMyPhotoList()
        }
      })
    },
    closeDialog() {
      this.editWorks_id = ''
      this.dialogVisible = false
    },
    editPhoto(id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.editWorks_id = id
      this.dialogVisible = true
    },
    // 登录
    loginFun () {
      const currentUrl = window.location.href
      window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + encodeURIComponent(currentUrl)
    },
    addVideo() {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      if(this.getUserInfo.isLogin) {
        this.dialogVisible = true
      } else {
        this.loginFun()
      }
    },
    deletePhoto(works_id) {
      this.$message({
        message: "作品征集已截止",
        type: "warning",
      });
      return
      this.$confirm('您确定要删除该作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$utils.postJson('/works/delWorks', {
          works_id
        }).then(res => {
          if(res.code == 1000) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            this.getMyPhotoList()
          }
        })
      })
    },
    // 获取我的图片故事
    getMyPhotoList() {
      this.$utils.get('/works/myWorks', {
        type: 2
      }).then(res => {
        if(res.code == 1000) {
          this.myPhotoList = [...res.data.photo]
        }

      })
    },
    // 管理图片故事
    checkPhoto(id) {
      this.$router.push('/pcpage/submitlist/photo_manage?id=' + id)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.videoUploadCon {
  .add {
    width: 360px;
    height: 226px;
    background-color: #e6eaf0;
    border: 3px solid #bfcada;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    margin-right: 13px;
    margin-bottom: 20px;
    img {
      margin-top: 50px;
    }
  }
  .videoItem {
    width: 360px;
    height: 226px;
    display: inline-block;
    vertical-align: top;
    margin-right: 13px;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    &:hover {
      .hoverInfo {
        opacity: 1;
        // display: block;
      }
      .coverCon {
        .info {
          display: none;
        }
        .fail {
          display: none;
        }
      }
    }
    .hoverInfo {
      // display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 360px;
      height: 226px;
      background-color: rgba(0,0,0,0.3);
      opacity: 0;
      transition: all linear 0.2s;
      .info {
        margin-left: 20px;
        margin-top: 20px;
        img {
          width: 40px;
        }
        span {
          display: inline-block;
          margin-left: 5px;
          vertical-align: top;
          margin-top: 10px;
          width: 280px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .des {
          font-size: 20px;
          width: calc(100% - 40px);
          color: #fff;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-top: 15px;
          line-height: 1.4;
        }
        .fail {
          width: calc(100% + 20px);
          height: 58px;
          line-height: 1.4;
          margin-top: 10px;
          padding: 10px;
          margin-left: -20px;
          font-size: 16px;
          color: #fff;
          box-sizing: border-box;
          background-color: #ff0707;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .operate {
          text-align: center;
          position: absolute;
          bottom: 20px;
          width: 100%;
          margin-left: -20px;
          .item {
            display: inline-block;
            color: #fff;
            font-size: 16px;
            margin: 0 10px;
            img {
              width: 32px;
              margin-bottom: 5px;
            }
            &:first-child {
              img {
                width: 24px;
              }
            }
            &:nth-child(3) {
              img {
                width: 28px;
              }
            }
            &:last-child {
              img {
                width: 30px;
              }
            }
          }
          .isJoin {
            cursor: auto;
          }
        }
      }
    }
    .coverCon {
      position: relative;
      .cover {
        width: 360px;
        height: 226px;
      }
      .fail {
        position: absolute;
        height: 58px;
        top: 67px;
        width: 100%;
        line-height: 1.4;
        padding: 10px;
        font-size: 16px;
        color: #fff;
        box-sizing: border-box;
        background-color: #ff0707;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .info {
        position: absolute;
        bottom: 20px;
        left: 20px;
        color: #fff;
        img {
          width: 40px;
        }
        span {
          display: inline-block;
          margin-left: 5px;
          vertical-align: top;
          margin-top: 10px;
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .uploadDialog {
      .title {
        color: #f64109;
        font-size: 18px;
      }

      .stepInfo {
        width: 100%;
        height: 62px;
        line-height: 62px;
        background-color: rgba(183, 183, 183, 0.36);
        span {
          font-size: 16px;
          color: #999;
          margin-right: 15px;
          margin-left: 15px;
        }
        .currentStep {
          color: #282828;
        }
      }
      .uploadVideoPic,
      .uploadVideoContent {
        margin-top: 35px;
        .chooseFile {
          background-color: #fff;
          border: 1px solid #ccc;
          color: #666;
          vertical-align: middle;
          img {
            vertical-align: bottom;
            margin-right: 5px;
          }
        }
        .chooseFile:hover {
          border: 1px solid #999;
        }
        .fileName {
          margin-left: 15px;
          color: #999;
        }
        .imgTip {
          font-size: 14px;
          color: #999;
          margin-left: 110px;
          margin-top: 24px;
          padding-bottom: 43px;
        }
      }
      .uploadVideoContent {
        margin-top: 35px;
      }
      .uploading {
        text-align: center;
        padding-bottom: 20px;
        .gif {
        }
      }
      .ruleForm {
        width: 500px;
        padding-bottom: 27px;
        margin: 27px auto 0;
      }
      .footer {
        width: 100%;
        height: 77px;
        background-color: #faf6f4;
        .submitBtn {
          background-color: #f8683b;
          border: 1px solid #dc8800;
          margin-top: 20px;
          margin-left: 25px;
        }
        .loading {
          vertical-align: top;
          margin-top: 25px;
          margin-left: 10px;
        }
        .closeBtn {
          margin-left: 15px;
          color: #999;
          cursor: pointer;
        }
      }
  }
}
</style>
